export default {
  currencySign: '$',
}